import config from './config';

const featureToggles = {
  savedJobs: true,
  uploadCV: true,
  creatorPartnership: true,
  // Feature toggle for the filters in client ATS
  clientATSFilters: !config.isProduction,
  // Allow-list of user IDs who always see client ATS filters, even in production
  clientATSFiltersUserIds: [2, 341236],
};

export default featureToggles;
